import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import LegacyButton from "legacy/LegacyButton"
import SegmentedControl from "legacy/SegmentedControl"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import ChargeItemsController from "legacy/charge-item/ChargeItemsController"
import {
  afterSetState,
  buildRoute,
  orderedAvailableCategories,
  updateUrlQueryParams,
} from "legacy/helpers.es6"
import CreateSaleContainer from "legacy/sales/CreateSaleContainer"
import ReceiptPrinterChooser from "legacy/sales/ReceiptPrinterChooser"
import SaleDetails from "legacy/sales/SaleDetails"
import SaleEmptyView from "legacy/sales/SaleEmptyView"
import SalesHistory from "legacy/sales/SalesHistory"
import PropTypes from "prop-types"
import React from "react"

class SalesContainer extends ApplicationComponent {
  constructor(args) {
    super(args)
    this.state = {
      posItems: this.props.editItemsProps.chargeItems,
      categories: "",
      selectedSale: this.props.selectedSale,
      view: this.props.view,
      sales: this.props.items,
      page: this.props.page,
      numberOfPages: this.props.pageCount,
      totalSalesCount: this.props.totalCount,
      isLoading: false,
      searchTerm: "",
      printerId: null,
      listedPumpPriceLastUpdatedAt:
        this.props.editItemsProps.listedPumpPriceLastUpdatedAt,
      openingCashDrawer: false,
      errorMessage: null,
    }
    this.handleOpenCashDrawer = this.handleOpenCashDrawer.bind(this)
    this.setSelectedSale = this.setSelectedSale.bind(this)
    this.setView = this.setView.bind(this)
    this.goToPage = this.goToPage.bind(this)
    this.fetchSales = this.fetchSales.bind(this)
    this.updateUrl = this.updateUrl.bind(this)
    this.isMobile = this.isMobile.bind(this)
    this.handleSaleCreated = this.handleSaleCreated.bind(this)
    this.handleUpdateSearchTerm = this.handleUpdateSearchTerm.bind(this)
    this.cashDrawerAvailable = this.cashDrawerAvailable.bind(this)
    this.cashDrawers = this.cashDrawers.bind(this)
    this.handleUpdatedPosItemTemplates =
      this.handleUpdatedPosItemTemplates.bind(this)
    this.renderTaxRate = this.renderTaxRate.bind(this)
    this.renderSearchInput = this.renderSearchInput.bind(this)
    this.renderOpenCashDrawerButton = this.renderOpenCashDrawerButton.bind(this)
    this.renderContent = this.renderContent.bind(this)
  }

  componentDidMount() {
    // Note: Amplitude is loaded globally
    Amplitude.trackEvent(`web_pos:${this.state.view}`)
    if (!this.isMobile() && !this.state.selectedSale) {
      this.setState({ selectedSale: this.state.sales[0] })
    }
    this.setState({
      categories: orderedAvailableCategories(
        this.state.posItems,
        $context.orderedCategories
      ),
    })
    afterSetState(this.updateUrl)
  }

  isMobile() {
    return window.innerWidth < 738
  }

  cashDrawerAvailable() {
    return (
      $context.receiptPrinters &&
      $context.receiptPrinters.length > 0 &&
      $context.openCashDrawerUrl !== null
    )
  }

  cashDrawers() {
    if (!this.cashDrawerAvailable()) return null

    return $context.receiptPrinters.filter((printer) => printer.cashDrawer)
  }

  fetchSales() {
    this.setState({ isLoading: true })
    // Note: jQuery ($) is loaded globally
    $.ajax({
      url: `${$context.salesEndpoint}?page=${this.state.page}`,
      type: "GET",
      dataType: "json",
      contentType: "application/json",
      success: (data) => {
        this.setState({
          isLoading: false,
          sales: data.items,
          numberOfPages: data.pageCount,
          totalSalesCount: data.totalCount,
        })
        afterSetState(this.updateUrl)
      },
      error: (data) => {
        this.setState({
          isLoading: false,
          errorMessage: data.responseJSON.error,
        })
      },
    })
  }

  goToPage(page) {
    this.setState({ page })
    afterSetState(() => {
      this.fetchSales()
      this.updateUrl()
    })
  }

  setSelectedSale(newSelectedSale) {
    // if there's a sale, update that sale in the sales array
    let updatedSales = this.state.sales
    if (newSelectedSale) {
      updatedSales = this.state.sales.map((sale) => {
        return sale.id === newSelectedSale.id ? newSelectedSale : sale
      })
    }
    this.setState({ selectedSale: newSelectedSale, sales: updatedSales })
    afterSetState(this.updateUrl)
  }

  handleSaleCreated(sale) {
    const updatedSales = this.state.sales
    updatedSales.unshift(sale)
    this.setState({ sales: updatedSales })
    afterSetState(() => {
      this.setSelectedSale(sale)
      this.setView("history")
    })
  }

  setView(view) {
    // Note: Amplitude is loaded globally
    Amplitude.trackEvent(`web_pos:${view}`)
    this.setState({ view })
    afterSetState(this.updateUrl)
  }

  updateUrl() {
    switch (this.state.view) {
      case "history": {
        window.history.replaceState(
          null,
          null,
          `${$context.salesEndpoint}${
            this.state.selectedSale ? `/${this.state.selectedSale.id}` : ""
          }`
        )
        updateUrlQueryParams({ page: this.state.page })
        break
      }
      case "new":
      case "edit":
        window.history.replaceState(
          null,
          null,
          `${$context.salesEndpoint}/${this.state.view}`
        )
        break
    }
  }

  handleUpdatedPosItemTemplates(newItemTemplates, listedPumpPriceLastUpdated) {
    this.setState({
      ...(listedPumpPriceLastUpdated && {
        listedPumpPriceLastUpdatedAt: listedPumpPriceLastUpdated,
      }),
      posItems: newItemTemplates,
      categories: orderedAvailableCategories(
        newItemTemplates,
        $context.orderedCategories
      ),
    })
  }

  handleUpdateSearchTerm(event) {
    let term = ""
    if (event) {
      term = event.target.value
    }
    this.setState({ searchTerm: term })
  }

  renderTaxRate(chargeItem) {
    if (chargeItem.taxIncluded) return "Included"
    if (chargeItem.taxRate) return `${chargeItem.taxRate}%`
  }

  renderSearchInput() {
    if (
      !(
        $context.packagingTransientReservationsEnabled ||
        $context.packagingPosEnabled
      )
    )
      return null
    if (this.state.view !== "edit" && !$context.packagingPosEnabled) return null
    if (this.state.view === "edit" && this.state.posItems.length === 0)
      return null

    return (
      <FormGroup
        label="Search Items"
        labelClassName="sr-only"
        placeholder="Search items by name"
        name="searchTerm"
        onChange={this.handleUpdateSearchTerm}
        value={this.state.searchTerm}
        className="mb-3"
        inputType="search"
        resetSearch={() => this.handleUpdateSearchTerm()}
      />
    )
  }

  renderOpenCashDrawerButton() {
    if (this.cashDrawerAvailable()) {
      return (
        <div className="flex shrink flex-row gap-2">
          <ReceiptPrinterChooser
            title="Select Cash Drawer"
            printers={this.cashDrawers()}
            handlePrinterSelection={(printerId) => this.setState({ printerId })}
          />
          <NextButton
            processing={this.state.openingCashDrawer}
            icon=""
            btnClass="btn btn-secondary self-center"
            text="Open Cash Drawer"
            processingText="Opening..."
            click={this.handleOpenCashDrawer}
          />
        </div>
      )
    }
  }

  handleOpenCashDrawer() {
    this.setState({ openingCashDrawer: true })
    // Note: jQuery ($) is loaded globally
    $.post(
      buildRoute($context.openCashDrawerUrl, {
        printer_id: this.state.printerId,
      }),
      null,
      (data) => {
        setTimeout(() => {
          this.setState({ openingCashDrawer: false })
        }, 2000) // we wait an additional 2 seconds to account for the delay with printer polling
      },
      "json"
    ).fail((data) => {
      const errorMessage = JSON.parse(data.responseText).error
      alert(
        `Error opening cash drawer: ${errorMessage}\n\nPlease check the printer and cash drawer and try again.`
      )
      this.setState({ openingCashDrawer: false })
    })
  }

  renderContent() {
    switch (this.state.view) {
      case "history":
        if (this.state.sales.length === 0 || !$context.packagingPosEnabled) {
          return (
            <SaleEmptyView
              createUrl={$context.pointOfSalePath}
              canCreateNewSales={$context.canCreateSales}
            />
          )
        }
        return (
          <div className="grid grid-cols-12 gap-3">
            <div
              className={`card relative col-span-12 md:col-span-4 md:inline ${
                this.state.selectedSale ? "hidden" : ""
              }`}
            >
              <SalesHistory
                sales={this.state.sales}
                isLoading={this.state.isLoading}
                errorMessage={this.state.errorMessage}
                setSelectedSale={this.setSelectedSale}
                selectedSale={this.state.selectedSale}
                goToPage={this.goToPage}
                page={this.state.page}
                numberOfPages={this.state.numberOfPages}
                totalSalesCount={this.state.totalSalesCount}
              />
            </div>
            {this.state.selectedSale && (
              <div className="card relative col-span-12 px-6 md:col-span-8">
                <SaleDetails
                  sale={this.state.selectedSale}
                  setSelectedSale={this.setSelectedSale}
                />
              </div>
            )}
          </div>
        )
      case "edit":
        if (
          !(
            $context.packagingTransientReservationsEnabled ||
            $context.packagingPosEnabled
          )
        ) {
          return <SaleEmptyView />
        }
        return (
          <ChargeItemsController
            {...this.props.editItemsProps}
            chargeItems={this.state.posItems}
            listedPumpPriceLastUpdatedAt={
              this.state.listedPumpPriceLastUpdatedAt
            }
            handleUpdateItems={this.handleUpdatedPosItemTemplates}
            handleUpdateSearchTerm={this.handleUpdateSearchTerm}
            searchTerm={this.state.searchTerm}
            renderTaxRate={this.renderTaxRate}
          />
        )
      case "new":
        if (!$context.packagingPosEnabled) {
          return <SaleEmptyView />
        } else if (this.state.posItems.length === 0) {
          return (
            <div className="card mt-3">
              <h2 className="mt-0 text-xl">
                Let&apos;s make some money, shall we?
              </h2>
              <p>
                To begin making new sales add items with a price and one time
                frequency.
              </p>
              <LegacyButton type="primary" onClick={() => this.setView("edit")}>
                Create and edit items
              </LegacyButton>
            </div>
          )
        }
        return (
          <CreateSaleContainer
            isMobile={this.isMobile}
            posItems={this.state.posItems}
            categories={this.state.categories}
            handleSaleCreated={this.handleSaleCreated}
            handleUpdateSearchTerm={this.handleUpdateSearchTerm}
            searchTerm={this.state.searchTerm}
            renderTaxRate={this.renderTaxRate}
            listedPumpPriceLastUpdatedAt={
              this.state.listedPumpPriceLastUpdatedAt
            }
          />
        )
    }
  }

  render() {
    return (
      <div className="mb-8">
        <div
          className={`container grid grid-cols-8 gap-x-3 md:grid-cols-12 ${
            this.state.view === "edit" ? "edit-items-facade sticky" : ""
          } `}
        >
          {this.state.view !== "history" && (
            <div className="order-1 col-span-full mb-3 md:order-none md:col-span-4 md:col-start-1 md:mb-0">
              {this.renderSearchInput()}
            </div>
          )}
          {this.state.view === "history" && (
            <div className="col-span-full md:col-span-4 md:col-start-1">
              {this.renderOpenCashDrawerButton()}
            </div>
          )}
          {$context.packagingPosEnabled &&
            !$context.anyMbmPosFeatureEnabled && (
              <div className="col-span-full self-center md:col-span-4 md:col-start-9">
                <SegmentedControl
                  style="blue"
                  handleSelection={this.setView}
                  segments={[
                    { id: "new", title: "New Sale" },
                    { id: "edit", title: "Edit Items" },
                    {
                      id: "history",
                      title: "History",
                    },
                  ]}
                  selectedSegment={this.state.view}
                />
              </div>
            )}
        </div>
        <div className="container">{this.renderContent()}</div>
      </div>
    )
  }
}

SalesContainer.propTypes = {
  view: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  selectedSale: PropTypes.object,
  editItemsProps: PropTypes.shape({
    chargeItems: PropTypes.array.isRequired,
    listedPumpPriceLastUpdatedAt: PropTypes.string,
  }).isRequired,
}

export default SalesContainer
